import React from 'react'

function PlanDetails({ plan, currentPlan, children }) {
    return (
        <div
            className={`flex flex-wrap items-center justify-start w-full bg-white ${currentPlan?.plan === plan.plan ? 'border-2 border-green-500' : 'border'} rounded-lg shadow-md group`}>
            <div className="w-full xl:w-1/4 md:w-1/4 md:pl-6">
                <div className="relative flex flex-col h-full py-5 md:py-8 px-4 bg-gray-50 rounded-lg md:bg-white md:border-l text-center">
                    <h2 className="mb-2 text-2xl md:2text-xl font-bold text-green-500 tracking-tight">
                        {plan.hebrew}
                    </h2>
                    <p className="mb-2 text-base font-normal text-gray-500 text-sm tracking-tight">{plan.title}</p>
                </div>
            </div>
            {children}
        </div>
    )
}

export default PlanDetails